var CryptoJS = require("crypto-js");
const _decrypt = props => {
    try {
        const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPT_KEY);
        const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPT_KEY);
        var bytes  = CryptoJS.AES.decrypt(props, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            feedbacksize: 128
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    } catch (err) {
        return "";
    }
}

export default _decrypt;